module.exports = __webpack_public_path__ + "img/coinbase-gateway.1a378d71.svg";